module.exports = __webpack_public_path__ + "img/macStep5.2d82d781.png";